import { GtmInteractor } from '../gtmInteractor';

const FALLBACK_VALUE = 'NV';
export interface MerchantAdClickedEvent {
  eventAction?: string;
  merchantPartnerStoreID?: string | number;
  merchantPartnerName?: string;
}

type EventLabel = 'intern' | 'extern';

const merchantAdClicked = (
  gtm: GtmInteractor,
  { eventAction, merchantPartnerStoreID, merchantPartnerName }: MerchantAdClickedEvent,
  eventLabel: EventLabel,
) => {
  return gtm.push({
    event: 'event',
    eventCategory: 'merchantAdClick',
    eventLabel,

    eventAction: eventAction || FALLBACK_VALUE,
    merchantPartnerStoreID: merchantPartnerStoreID || FALLBACK_VALUE,
    merchantPartnerName: merchantPartnerName || FALLBACK_VALUE,
  });
};

export const merchantAdClickedInternal = (gtm: GtmInteractor) => (data: MerchantAdClickedEvent) =>
  merchantAdClicked(gtm, data, 'intern');

export const merchantAdClickedExternal = (gtm: GtmInteractor) => (data: MerchantAdClickedEvent) =>
  merchantAdClicked(gtm, data, 'extern');

export interface MerchantAdLoadedEvent {
  merchantPartnerID: string;
  merchantPartnerStoreID?: string | number;
  merchantCity: string;
  merchantPartnerStatus: string;
  merchantPartnerName: string;
}

export const merchantAdLoaded =
  (gtm: GtmInteractor) =>
  ({
    merchantPartnerID,
    merchantPartnerStoreID,
    merchantCity,
    merchantPartnerStatus,
    merchantPartnerName,
  }: MerchantAdLoadedEvent) => {
    return gtm.push({
      event: 'event',
      eventCategory: 'merchantAdView',
      eventAction: 'view',
      merchantPartnerID: merchantPartnerID || FALLBACK_VALUE,
      merchantPartnerStoreID: merchantPartnerStoreID || FALLBACK_VALUE,
      merchantCity: merchantCity || FALLBACK_VALUE,
      merchantPartnerStatus: merchantPartnerStatus || FALLBACK_VALUE,
      merchantPartnerName: merchantPartnerName || FALLBACK_VALUE,
    });
  };
